// Imports for external libraries go here.
/* eslint-disable @nx/enforce-module-boundaries */
import { FC } from 'react';
import { TabContainerProps } from './TabContainer.types';
import { StyledTabContainer } from './TabContainer.styles';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { TabContainer } from '@marriott/mi-common-static-components';
import { useDCADynamicModelAlloy } from '../../modules/helpers';
import clsx from 'clsx';

export const TabContainerComp: FC<TabContainerProps> = props => {
  /**
   * Fetching the target response
   */
  const mboxParam = props?.model?.mboxParameter;

  /***
   * Makes the call to target if mboxParam is authored
   */
  const targetResponse = useDCADynamicModelAlloy(mboxParam);
  const targetData = targetResponse?.targetData;

  return (
    <StyledTabContainer
      data-testid="luxury-TabContainer"
      data-component-name="o-luxury-TabContainer"
      className={clsx('m-container-fullbleed', props?.model?.styleclass)}
    >
      {targetData ? (
        <TabContainer
          {...targetData}
          key="data from target"
          model={targetData}
          componentPath="mi-luxury-components"
          isAuthorMode={props?.isAuthorMode ?? false}
          flexibleTabWidth={targetData?.flexibleTabWidth}
          allowedComponents={props?.allowedComponents}
          tabsPerViewInDesktop={5}
        />
      ) : (
        <TabContainer
          {...props}
          key="data from model"
          model={props?.model}
          isAuthorMode={props?.isAuthorMode ?? false}
          flexibleTabWidth={props?.model?.flexibleTabWidth}
          allowedComponents={props?.allowedComponents}
          tabsPerViewInDesktop={5}
        />
      )}
    </StyledTabContainer>
  );
};

export const TabContainerConfig = {
  emptyLabel: 'TabContainer',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/tabcontainer`,
};
//TODO:Need to fix the lint issue for editable component
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const TabEditableComponent = (props: any) => {
  return (
    <EditableComponent config={TabContainerConfig} {...props}>
      <TabContainerComp {...props} />
    </EditableComponent>
  );
};
